import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewRef } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-site-logo',
  templateUrl: './site-logo.component.html',
  styleUrls: ['./site-logo.component.scss'],
  standalone: false,
})
export class SiteLogoComponent implements OnInit, OnDestroy {
  useSiteLogoTemplate = true;
  hasRequested = 'false';
  siteLogo$: Observable<any> = this.componentData.data$;
  urlLink: string;
  disabledLinkLogo = false;
  hasLink$: Subscription;

  constructor(
    private componentData: CmsComponentData<any>,
    protected cms: CmsService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    if (this.f === 'true') {
      this.hasRequested = this.f;
    }

    this.hasLink$ = this.componentService.siteLogoLinkDisable$.subscribe((isDisable) => {
      this.disabledLinkLogo = isDisable;
      this.cdr.detectChanges();
    });

    this.cms.getCurrentPage().subscribe((page) => {
      if (page) {
        if (page.template === 'DealerSelectionPageTemplate' || page.template === 'UnitSelectionPageTemplate') {
          this.disabledLinkLogo = true;
        } else {
          this.disabledLinkLogo = false;
        }
      }
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
      this.siteLogo$.pipe(take(1)).subscribe((data) => {
        if (data && data.urlLink) {
          this.urlLink = data.urlLink;
        }
      });
    });
  }

  get f() {
    return this.storageService.getLocalStorageItem('hasRequested');
  }

  ngOnDestroy() {
    if (this.hasLink$) {
      this.hasLink$.unsubscribe();
    }
  }
}
